
import { defineComponent, onMounted, PropType, ref } from 'vue';
import { WorkListing } from '@/types.ts';
import WorksGridItem from '@/components/WorksGridItem.vue';

export default defineComponent({
  components: {
    WorksGridItem,
  },
  emits: ['enter', 'leave'],
  props: {
    works: {
      type: Array as PropType<Array<WorkListing>>,
      default: () => [],
    },
  },
  setup(props, { emit }) {
    const active = ref(false);
    const el = ref<HTMLElement | null>(null);

    onMounted(() => {
      if (el.value) {
        // const threshold = Array.from(Array(101).keys()).map((i) => i / 100);
        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              emit('enter');
            } else {
              emit('leave');
            }
          },
          { threshold: [0.75] }
        );
        observer.observe(el.value);
      }
    });
    return { active, el };
  },
});
